import React from 'react';
import Button from '../../../components/ui/Button';

const QuickActions = ({ onAddProperty, onViewAnalytics, onManageInquiries, onUpdateProfile }) => {
  const actions = [
    {
      title: 'Add New Property',
      description: 'List a new property with our guided wizard',
      icon: 'Plus',
      variant: 'default',
      onClick: onAddProperty
    },
    {
      title: 'View Analytics',
      description: 'Check performance metrics and insights',
      icon: 'BarChart3',
      variant: 'outline',
      onClick: onViewAnalytics
    },
    {
      title: 'Manage Inquiries',
      description: 'Respond to potential tenant inquiries',
      icon: 'MessageSquare',
      variant: 'outline',
      onClick: onManageInquiries
    },
    {
      title: 'Update Profile',
      description: 'Complete verification and profile setup',
      icon: 'User',
      variant: 'outline',
      onClick: onUpdateProfile
    }
  ];

  return (
    <div className="bg-surface rounded-lg border border-border p-6 shadow-property-card">
      <h3 className="text-lg font-semibold text-text-primary mb-4">Quick Actions</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {actions.map((action, index) => (
          <div key={index} className="p-4 border border-border rounded-lg hover:bg-muted transition-quick">
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0">
                <Button
                  variant={action.variant}
                  size="sm"
                  iconName={action.icon}
                  onClick={action.onClick}
                />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-medium text-text-primary mb-1">
                  {action.title}
                </h4>
                <p className="text-xs text-text-secondary line-clamp-2">
                  {action.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;